import React, { createRef, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ACTIONS } from '../../redux/actions'
import { HeadersPath, path } from '../../Utils/ScreenPath'
import DynamicActionBar from '../../Common/DynamicActionBar'
import { useNavigate } from 'react-router-dom'
import CustomInput from '../../Common/CustomInput'
import bookmark from '../../assets/images/bookmark.png';
import clipboard from '../../assets/images/clipboard.png';
import Exam from '../../assets/images/Exam.png';
import profile from '../../assets/images/profile.png';
import Buliding from '../../assets/images/Buliding.png';
import call from '../../assets/images/call.png';
import task from '../../assets/images/task.png';
import { ErrorToast, SuccessToast } from '../../Common/Toast'
import CustomDropdown from '../../Common/CustomDropdown'
import { Build } from '@mui/icons-material'
import { indianStates, stateWiseCities } from '../../Utils/Constants'
import { Button } from '../../Common/Button'
import { Api } from '../../Service/api'
import { getlocalStorage, setlocalStorage } from '../../Service/api/configuration/localstorage'
import { Edit } from 'lucide-react'

const ProfileInfo = ({
  name = "John Doe",
  email = "2H2oC@example.com",
  avatarUrl = "https://i.ibb.co/2Z7yX2z/Profile.png",
}) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const fileInputRef = createRef();

  const boardDataList = useSelector((state) => state?.Board?.BoardData || {});
  const mediumDataList = useSelector((state) => state?.Medium?.MediumData || {});
  const standardDataList = useSelector((state) => state?.Standard?.StandardData || {});
  const GetUser = useSelector((state) => state?.GetUser?.GetUserData || {});
  const userData = getlocalStorage("userData");
  const userDataInfo = GetUser?.data?.userInfo || {}
  const [boardData, setBoardData] = useState([])
  const [mediumData, setMediumData] = useState([])
  const [standardData, setStandardData] = useState([])
  const [profileData, setProfileData] = React.useState({
    name: userDataInfo?.first_name,
    schoolName: userDataInfo?.school_name,
    email: userDataInfo?.email,
    phoneNumber: userDataInfo?.school_name,
    board: userDataInfo?.boardInfo,
    medium: userDataInfo?.mediumInfo,
    standard: userDataInfo?.standardInfo,
    state: {
      id: userDataInfo?.state?.id,
      label: userDataInfo?.state
    },
    city: {
      id: userDataInfo?.city?.id,
      label: userDataInfo?.city
    },
  })
  const handleBackClick = () => {
    navigate(-1)
  }

  const handleImageClick = () => {
    fileInputRef.current.click();
  };

  const handleProfileDataChange = (value, key) => {
    if (key === "phoneNumber" && value.length > 10) { return }
    const newProfileData = { ...profileData, [key]: value }
    setProfileData(newProfileData)

    if (key === "board") {
      setProfileData((prev) => ({
        ...prev,
        medium: '',
        standard: '',
        [key]: value
      }))
      setMediumData([])
      setStandardData([])
    }

    if (key === "medium") {
      let payload = {
        ...profileData,
        standard: '',
        [key]: value
      }
      setProfileData(payload)
      setStandardData([])
    }

    if (key === "state") {
      let payload = {
        ...profileData,
        city: '',
        [key]: value
      }
      setProfileData(payload)
    }
  }

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append("image", file);

    const { data } = await Api.uplodedImage(formData)
    const result = JSON.parse(data);
    if (result) {
      setProfileData((prevData) => ({
        ...prevData,
        image: result?.data,
      }));
    };
  }

  const handleUpdateProfile = async () => {
    dispatch(ACTIONS.startLoading())
    try {
      let body = {
        id: userData?.user_id,
        data: JSON.stringify({
          first_name: profileData?.name,
          school_name: profileData?.schoolName,
          email: profileData?.email,
          state: profileData?.state?.label,
          city: profileData?.city?.label,
          standard_id: profileData?.standard?.id,
          board_id: profileData?.board?.id,
          medium_id: profileData?.medium?.id,
          image: profileData?.image,
        }),
      }
      const { data } = await Api.UpdateProfile(body)
      const res = JSON.parse(data);
      if (res?.status == 200) {
        SuccessToast(res?.message);
        navigate(path.Profile)
      }
    } catch (e) {
      ErrorToast(e);
    } finally {
      dispatch(ACTIONS.stopLoading())
    }
  }


  const handleGetBoard = async () => {
    dispatch(ACTIONS.startLoading())
    try {
      let params = {
        isOthers: true,
      }
      dispatch(ACTIONS.getBoardData(params))
    } catch (e) {
      ErrorToast(e);
    } finally {
      dispatch(ACTIONS.stopLoading())
    }
  }

  const handleGetMedium = async () => {
    dispatch(ACTIONS.startLoading())
    try {
      let params = {
        board: profileData?.board?.id,
        isOthers: true,
      }
      dispatch(ACTIONS.getMediumData(params))
    } catch (e) {
      ErrorToast(e);
    } finally {
      dispatch(ACTIONS.stopLoading())
    }
  }

  const handleGetStandard = async () => {
    dispatch(ACTIONS.startLoading())
    try {
      let params = {
        medium: profileData?.medium?.id,
        isManual: true,
        isLearn: false,
      }
      dispatch(ACTIONS.getStandardData(params))
    } catch (e) {
      ErrorToast(e);
    } finally {
      dispatch(ACTIONS.stopLoading())
    }
  }


  useEffect(() => {
    if (boardDataList?.status === 200) {
      setBoardData(boardDataList)
    }
  }, [boardDataList])

  useEffect(() => {
    // if(mediumDataList?.status === 200){
    setMediumData(mediumDataList)
    // }
  }, [mediumDataList])

  useEffect(() => {
    if (standardDataList?.status === 200) {
      setStandardData(standardDataList)
    }
  }, [standardDataList])

  useEffect(() => {
    if (profileData?.board) {
      handleGetMedium()
    }
  }, [profileData?.board])

  useEffect(() => {
    if (profileData?.medium) {
      handleGetStandard()
    }
  }, [profileData?.medium])

  useEffect(() => {
    handleGetBoard()
    dispatch(ACTIONS.getHeaderPath(HeadersPath.Profile))
  }, [])

  return (
    <div className="pb-8">
      <DynamicActionBar
        showArrowLeft
        backButtonLabel={"Edit Personal Information "}
        onBackClick={handleBackClick}
      />

      <div className="flex items-center my-8 p-4 bg-white shadow-md rounded-lg  mx-auto">
        <div className="relative">
          <img src={profileData?.image || GetUser?.data?.userInfo?.image} alt={name} onClick={handleImageClick} className="w-16 h-16 rounded-full mr-4" />
          <button
            className="absolute bottom-0 right-[20px] bg-blue-500 rounded-full p-1 cursor-pointer"
            aria-label="Edit profile picture"
          >
            <Edit style={{ color: '#fff' }} size={12} />
          </button>
        </div>
        <input
          type="file"
          accept="image/*"
          ref={fileInputRef}
          style={{ display: 'none' }}
          onChange={handleImageChange} // Attach change handler
        />
        <div>
          <h2 className="text-xl font-semibold">{GetUser?.data?.userInfo?.first_name}</h2>
          <p className="text-gray-600 text-sm">{GetUser?.data?.userInfo?.email}</p>
        </div>
      </div>

      <div className="text-xl font-semibold pb-4">
        Personal Information
      </div>
      <div className="flex flex-col lg:flex-row gap-2 lg:gap-4">
        <div className="w-full  max-w-[450px]">
          <CustomInput
            type="text"
            label="Full Name"
            placeholder="Enter Name"
            value={profileData?.name}
            onChange={(value) => handleProfileDataChange(value, "name")}
            icon={<img src={profile} alt="Building Icon" className="w-5 h-5" />}
          />
        </div>
        <div className=" w-full  max-w-[450px]">
          <CustomInput
            type="text"
            label="School Name"
            placeholder="Enter Name"
            value={profileData?.schoolName}
            onChange={(value) => handleProfileDataChange(value, "schoolName")}
            icon={<img src={Buliding} alt="Building Icon" className="w-5 h-5" />}
          />
        </div>
        <div className=" w-full  max-w-[450px]">
          <CustomInput
            type="text"
            label="Email"
            placeholder="Enter mail"
            value={profileData?.email}
            onChange={(value) => handleProfileDataChange(value, "email")}
            icon={<img src={task} alt="Building Icon" className="w-5 h-5" />}
          />
        </div>
        <div className=" w-full  max-w-[450px]">
          <CustomInput
            type="number"
            label="Mobile No."
            placeholder="Enter No."
            value={profileData?.phoneNumber}
            disabled={true}
            onChange={(value) => handleProfileDataChange(value, "phoneNumber")}
            icon={<img src={call} alt="Building Icon" className="w-5 h-5" />}
          />
        </div>
      </div>
      <div className="text-xl font-semibold py-4">
        Eduaction
      </div>
      <div className="flex flex-col flex-wrap lg:flex-row gap-2 lg:gap-4">
        <div className="w-full  max-w-[450px]">
          <CustomDropdown
            title="Select Board"
            data={boardData?.data || []}
            textKey="board_name"
            onSelect={(e) => handleProfileDataChange(e, "board")}
            defaultValue={profileData?.board?.board_name || "Select Board"}
            icon={<img src={Exam} alt="Exam Icon" className="w-5 h-5" />}
          />
        </div>
        <div className="w-full  max-w-[450px]">
          <CustomDropdown
            title="Select Medium"
            data={profileData?.board ? mediumData?.data : [] || []}
            textKey="name"
            onSelect={(e) => handleProfileDataChange(e, "medium")}
            defaultValue={profileData?.medium?.name || "Select Medium"}
            icon={<img src={bookmark} alt="Exam Icon" className="w-5 h-5" />}
          />
        </div>
        <div className="w-full  max-w-[450px]">
          <CustomDropdown
            title="Select Standard"
            data={profileData?.medium ? standardData?.data : [] || []}
            textKey="name"
            onSelect={(e) => handleProfileDataChange(e, "standard")}
            defaultValue={profileData?.standard?.name || "Select Standard"}
            icon={<img src={clipboard} alt="Exam Icon" className="w-5 h-5" />}
          />
        </div>
      </div>
      <div className="text-xl font-semibold py-4">
        Location
      </div>

      <div className="flex flex-col lg:flex-row gap-2 lg:gap-4">
        <div className="w-full  max-w-[450px]">
          <CustomDropdown
            title="State"
            data={indianStates || []}
            textKey="label"
            onSelect={(e) => handleProfileDataChange(e, "state")}
            defaultValue={profileData?.state?.label || "Select state"}
            icon={<img src={Exam} alt="Exam Icon" className="w-5 h-5" />}
          />
        </div>
        <div className="w-full max-w-[450px]">
          <CustomDropdown
            title="City"
            data={stateWiseCities[profileData?.state?.label] || []}
            textKey="label"
            onSelect={(e) => handleProfileDataChange(e, "city")}
            defaultValue={profileData?.city?.label || "Select city"}
            icon={<img src={bookmark} alt="Exam Icon" className="w-5 h-5" />}
          />
        </div>
      </div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '20px 10px' }}>
        <div style={{ width: '75px' }}>
          <Button
            id=""
            type="button"
            label={"Save"}
            onClick={handleUpdateProfile}
          />
        </div>
      </div>
    </div>
  )
}

export default ProfileInfo